<div class="text-center pd-t-100">
  <h2>Room is locked</h2>
  <h4>Please knock to ask host to join.</h4>
  <div>
    <button type="button" class="btn btn-primary" (click)="knock()">Knock</button>
  </div>
</div>
